import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/LoyaltyService';
import { AuthenticatedRepository, authStates } from '~repositories/AuthenticatedRepository';
import { root } from '@estee/elc-universal-utils';
import { ISiteConfig } from '~domain/entities/ISiteConfig';

export class LoyaltyDashboardLoadedUseCase {
    private authenticatedRepository: AuthenticatedRepository;

    constructor() {
        this.authenticatedRepository = diContainer.get(serviceNames.authenticatedRepository);
    }

    public async execute() {
        if (this.authenticatedRepository.JWTAPIEnabled) {
            await this.authenticatedRepository.fetchJWTAndUserAuthData();
        } else {
            await this.authenticatedRepository.fetchUserAuthState();
        }

        const { authState } = this.authenticatedRepository;
        const { loyaltyActiveFlag: isLoyalty } = this.authenticatedRepository;

        const loyaltyConfig = (window?.site as ISiteConfig)?.loyaltyConfig?.loyalty;
        import(`../../config/${loyaltyConfig.domain}-drupal.json`).then(
            data =>  {
                const { loyaltyMarketingPath, signinPath, userProfilePage } = data.loyaltyConfig;
                if (authState !== authStates.SIGNEDIN) {
                    return (root.location.href = signinPath);
                }
                if (authState === authStates.SIGNEDIN && !isLoyalty) {
                    return (root.location.href = (!userProfilePage ? loyaltyMarketingPath : userProfilePage));
                }
            }
        );
    }
}
